"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pwdText = exports.passwordWrapper = exports.inputStyles = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var inputStyles = function inputStyles(theme, textAlign, isPwdInput) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:100%;display:inline-block;box-sizing:border-box;padding:6px;font-size:", _styleConsts.font.size.large, ";border:none;background-color:transparent;color:", theme.color.black1, "\n  \n  ", textAlign === 'right' && "\n    text-align: right;\n  ", "\n  \n  ", textAlign === 'left' && "\n    text-align: left;\n  ", "\n\n  ", isPwdInput && "\n    padding-right: 40px;\n  ", "\n  \n  &[disabled]{opacity:", theme.disabledOpacity, ";cursor:not-allowed;}")
  );
};

exports.inputStyles = inputStyles;

var passwordWrapper = function passwordWrapper() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;display:flex;align-items:center;width:100%")
  );
};

exports.passwordWrapper = passwordWrapper;

var pwdText = function pwdText(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;color:", theme.color.accent, ";font-size:14px;line-height:18px;right:0px;cursor:pointer;z-index:1;")
  );
};

exports.pwdText = pwdText;